export enum StatsActions {
  SetYear = 'Set stats year',
  SetSelectedRooms = 'Set selected stats rooms',
  SetChartsType = 'Set stats charts Type',
  SetStats = 'set chart statistic',
  LoadStats = 'Load statistic',
  SetMonth = 'Set stats month',
}
